import { render, staticRenderFns } from "./RegularRequest.vue?vue&type=template&id=6e31ed41&"
import script from "./RegularRequest.vue?vue&type=script&lang=js&"
export * from "./RegularRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports